import type { ComputedRef, InjectionKey } from 'vue'

// A layout that draws its own header row provides the selector its page actions move into; null keeps them in place.
const PAGE_HEADER_ACTIONS_TARGET: InjectionKey<ComputedRef<string | null>> = Symbol('PageHeaderActionsTarget')

export { PAGE_HEADER_ACTIONS_TARGET }
